import { SmoothScroll } from "@/components/SmoothScroll";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Features } from "@/components/landing/Features";
import { Manifesto } from "@/components/landing/Manifesto";
import { Footer } from "@/components/landing/Footer";

export default function Landing() {
  return (
    <SmoothScroll>
      <main
        className="relative min-h-screen bg-[#0A0A0A] font-body text-white"
        data-testid="landing-page"
      >
        <Header />
        <Hero />
        <Marquee />
        <Features />
        <Manifesto />
        <Footer />
      </main>
    </SmoothScroll>
  );
}
